export default __webpack_public_path__ + "static/media/facebook-white.934ac2bc.svg";